import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import { MdmSecurityInfoFeatureKey, SecurityInfoReducer } from './security-info.reducer';
import { EffectsModule } from '@ngrx/effects';
import { SecurityInfoEffects } from './security-info.effects';

@NgModule({
  imports: [
    CommonModule,
    StoreModule.forFeature(MdmSecurityInfoFeatureKey, SecurityInfoReducer),
    EffectsModule.forFeature([SecurityInfoEffects]),
  ],
  providers: [],
})
export class SecurityInfoStoreModule {}
